// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { Grid as MuiGrid, useTheme } from "@mui/material";
import useMediaQuery from "../useMediaQuery";

function getSpacing(isContainer, isLg) {
  // spacing can only be used on a type `container` grid
  if (!isContainer) {
    return undefined;
  }
  // lg>: 24px; <lg: 16px
  return isLg ? 3 : 2;
}

/**
 * Our grid containers use a default custom spacing according to the browser breakpoint.
 * Spacing can be overwritten with the `spacing` prop.
 *
 * There are no other differences from MaterialUI.
 *
 * https://material-ui.com/api/grid/
 */
const Grid = (props) => {
  const theme = useTheme();
  // disable SSR to prevent double rendering
  const isLg = useMediaQuery(theme.breakpoints.up("lg"), { noSsr: true });
  const spacing = props.spacing ?? getSpacing(!!props.container, isLg);
  return <MuiGrid {...props} spacing={spacing} />;
};

export default Grid;
